import {Injectable} from '@angular/core';
import {isNative} from "../utils";
import {Share} from "@capacitor/share";

@Injectable({
  providedIn: 'root'
})
export class ShareService {
  public canShare(data: {url: string, title: string}) {
    return isNative || (navigator && navigator['share'] && navigator.canShare(
      data
    ))
  };

  public async share(data: {url: string, title: string}) {
    if (isNative) {
      try {
        await Share.share({
          title: data.title,
          url: data.url
        });
      }
      catch (e) {
        console.log('Share cancelled');
      }
    } else {
      await navigator.share(data);
    }
  }
}
